import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SECTORS } from "@/data/content";

const SectorPanel = ({ data, index }) => (
  <div data-testid={`sector-${data.label.toLowerCase()}`} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
    <div className={index % 2 === 1 ? "lg:order-2" : ""}>
      <Reveal>
        <div className="frame relative overflow-hidden rounded-sm aspect-[3/4] max-h-[640px] border border-white/10">
          <img src={data.image} alt={`${data.label} projects`} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          <span className="absolute bottom-6 left-6 font-serif text-3xl text-white">{data.label}</span>
        </div>
      </Reveal>
    </div>

    <div className={index % 2 === 1 ? "lg:order-1" : ""}>
      <Reveal delay={0.1}>
        <p className="overline text-[#d4af37] mb-6">{data.label} Sector</p>
        <ul className="divide-y divide-white/10 border-y border-white/10">
          {data.items.map((item, i) => (
            <motion.li
              key={item}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="group flex items-center gap-5 py-4"
            >
              <span className="text-[#d4af37] text-xs">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-serif text-xl md:text-2xl text-white/85 group-hover:text-white transition-colors">
                {item}
              </span>
            </motion.li>
          ))}
        </ul>
      </Reveal>
    </div>
  </div>
);

export const Sectors = () => (
  <section id="sectors" data-testid="sectors" className="max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
    <Reveal className="mb-20 md:mb-28 max-w-3xl">
      <p className="overline text-[#d4af37] mb-6">Who We Serve</p>
      <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
        One brand for homeowners, investors, developers and institutions.
      </h2>
    </Reveal>

    <div className="space-y-28 md:space-y-40">
      <SectorPanel data={SECTORS.residential} index={0} />
      <SectorPanel data={SECTORS.commercial} index={1} />
    </div>
  </section>
);
